/** 天幕设备弹窗 mixin  */
import { DEVICE_ROLE } from '@/utils/enums'
import { GetTianMuChildDeviceList } from '@/axios/IDevice.js'
import { alerterror } from '@/assets/js/common.js'
export default {
  data() {
    return {
      showTianMu: false, // 是否天幕
      childDeviceList: [], // 子设备列表
      PlanName: '', //绑定方案名称
      PlanId: '', //绑定方案ID
      LibraryList: [], // 方案库
      showOneKeyUp: false, //是否显示一键升级按钮
      showKeyUp:true, // 子设备是否显示升级按钮
      allVersionMap: {}, // 所有的version 信息
    }
  },
  methods: {
    // 处理设备信息
    handleTianMu() {
      if (this.model) {
        this.showTianMu = this.model.DeviceRole === DEVICE_ROLE.TianMu
        
        if (this.showTianMu) {
          this.getChildDeviceList()
        }
      }
    },

    // 获取子设备
    async getChildDeviceList() {
      const { Result, StatusCode } = await GetTianMuChildDeviceList({ vDeviceId: this.model?.VDeviceId })
      if (StatusCode == this.$store.state.rightStatusCode) {
        const { PlanId, PlanName, Devices } = Result
        this.PlanId = PlanId
        this.PlanName = PlanName
        // 规避子设备为null
        let _Devices = (Devices || []).filter(item => Boolean(item))
        this.childDeviceList = _Devices.map(item => {
          return {
            ...item,
            ref: `OppleOtaCards${item.VDeviceId}`,
            OtaActionList: [],
          }
        })
        this.getChildDeviceListActionList()
      }
    },
    // 天幕设备解绑
    unbindTianMu() {
      // this.blue_set1 = false
      // this.blue_set2 = false
      // this.blue_set3 = false
      // this.blue_set4 = false
      // this.blue_set5 = false
      // this.blue_set6 = false
      this.pannelControl(6)
    },

    // 子设备删除回调 && 重启
    deletedeviceCallback() {
      this.getChildDeviceList()
      this.$emit('dosuccess', '', true)
    },

    //获取删除,解绑弹窗的titel
    getDelTianMuTitle(_type) {
      let title = ''
      if (_type === 2) {
        title = this.$t('tianmu.delTips')
      } else if (_type === 6) {
        title = this.$t('tianmu.unbindTips')
      } else if (_type === 7) {
        title = this.$t('tianmu.reBuildTips')
      }

      return title
    },

    //判断天幕上面 ,移动 && 删除 && 替换 && 重启按钮显示逻辑
    getButtonShow(type) {
      if (this.model) {
        this.showTianMu = this.model.DeviceRole === DEVICE_ROLE.TianMu
      }
      let show = true
      switch (type) {
        case 'move':
          //移动
          if (this.childTiamMuDevice) {
            show = false
          }
          break
        case 'del':
          if (this.childTiamMuDevice) {
            show = false
          }
          //删除
          break
        case 'replace':
          if (this.showTianMu) {
            show = false
          }
          if (this.childTiamMuDevice) {
            show = true
          }
          //替换
          break
        case 'calibrate':
          if (this.showTianMu) {
            show = false
          }
          if (this.childTiamMuDevice) {
            show = true
          }
          //校准
          break
        case 'restart':
          if (this.showTianMu) {
            show = false
          }
          if (this.childTiamMuDevice) {
            show = true
          }
          break
      }
      return show
    },

    //获取子设备的能力表
    getChildDeviceListActionList() {},
    // 一键OTA升级
    oneUpLevel() {
      this.childDeviceList.forEach(item => {
        const { ref } = item
        this.$refs[ref] && this.$refs[ref]?.[0]?.oneUplevel && this.$refs[ref][0].oneUplevel()
      })
    },
    //收集ota卡片是否需要升级信息
    showUpLevelBtn(VersionList, device) {
      try {
        const { VDeviceId } = device
        this.allVersionMap[VDeviceId] = VersionList
        const values = Object.values(this.allVersionMap)
        
        let find = values.find(item => {
          let _find = false
          if (Array.isArray(item)) {
            item.forEach(_item => {
              const { cardStatus } = _item
              // if (cardStatus?.isShowStartBtn && !cardStatus?.isStartDisabled) {
              //   _find = true
              // }
              if (cardStatus?.isShowCancelBtn) {
                _find = true
              }
            })
          }
          return _find
        })
        this.showKeyUp = Boolean(find)
      } catch (error) {}
    },
  },
}
